import { type FC, type ReactNode } from "react";

import { SectionLabel } from "./section_label";

// His template read-only: a run of sections under the page they're on.
export const TemplateOutlinePage: FC<{
  label?: string;
  children: ReactNode;
}> = ({ label, children }) => (
  <section className="flex flex-col gap-2">
    {label && <SectionLabel size="xs">{label}</SectionLabel>}
    <ul className="flex flex-col divide-y divide-slate-100 rounded-lg border border-slate-200 bg-white">
      {children}
    </ul>
  </section>
);

// One section of his template: its name, then what it reads and what it follows.
export const TemplateOutlineItem: FC<{ name: string; line: string }> = ({
  name,
  line,
}) => (
  <li className="px-3 py-2">
    <span className="block text-sm text-slate-800">{name}</span>
    <span className="block text-[11.5px] text-slate-500">{line}</span>
  </li>
);
